import React, { useState } from 'react'
import { Link, useNavigate } from "react-router-dom";
import { axiosInstance } from '../../Config';
import { toast } from 'react-toastify';

const AddReligious = () => {
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleNameChange = (e) => {
    setName(e.target.value);
    setError(""); 
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      setError("Religious Belief name is required");
      return;
    }

    setError("");

    try {
      const response = await axiosInstance.post('/addReligious', {
        name: name.trim()
      });

      if (response.data.success) {
        toast.success('Religious Belief added successfully')
        navigate('/religiousList')
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to add Religious Belief. Please try again.");
    }
  };

  return (
    <>
      <div id="layout-wrapper">
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="title-box mb-3 pb-1">
                <h4 className="mb-0 page-title">Add Religious</h4>
                <nav aria-label="breadcrumb" className="mt-1">
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard" className="new">
                        <i className="ri-home-4-fill me-1" /> Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/religiousList" className="new">
                         Religious
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Add Religious
                    </li>
                  </ol>
                </nav>
              </div>

              <div className="row justify-content-center">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      {error && (
                        <div className="alert alert-danger" role="alert">
                          {error}
                        </div>
                      )}
                      
                      <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                          <label className="mb-1 fw-medium">Religious Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={name}
                            onChange={handleNameChange}
                            maxLength={50}
                            placeholder="Enter Religious Belief name"
                            required
                          />
                          <small className="text-muted">
                            Max 50 characters
                          </small>
                        </div>
                        
                        <div className="text-end mb-2">
                          <button
                            type="button"
                            className="btn btn-secondary me-2 px-4"
                            onClick={() => navigate('/religiousList')}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-danger px-4"
                          >
                            Add Religious
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddReligious;